enum SemanticFormStyle {
  bookitup = 'bookitup',
  cosmos = 'cosmos',
  lily = 'lily',
  minimal = 'minimal',
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  BROWN = 'BROWN',
  GRAY = 'GRAY',
}

export default SemanticFormStyle;
